import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";

class LanThanhToanTable extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    let { itemShow } = this.state;
    let { showPhiKho, Type, StatusPaidHo } = this.props;
    let showLai =
      Type !== 2 || (Type === 2 && (StatusPaidHo === 2 || StatusPaidHo === 3));
    let showGoc =
      Type !== 2 || (Type === 2 && (StatusPaidHo === 2 || StatusPaidHo === 3));
    let showGop = Type === 2 && StatusPaidHo === 1;
    let isShowPhiKho = showPhiKho && Type !== 2 && Type !== 1;
    return List.map((item, index) => {
      var lstTP = [];
      if (item.ThuPaid) lstTP = item.ThuPaid.split(",");
      return (
        <tr key={"lanTHanhToan" + index}>
          <td>{item.IndexId}</td>
          <td className="text-left"> {getDate(item.Time)}</td>
          {showLai && (
            <td className="text-right">{formatNumber(item.ValuePaid)}</td>
          )}
          <td className="text-right">{formatNumber(item.OtheFeeHangKy)}</td>
          <td className="text-right">{formatNumber(item.PhiDongLaiCham)}</td>
          {showGoc && (
            <td className="text-right">{formatNumber(item.ValueGoc)}</td>
          )}
          {showGop && (
            <td className="text-right">
              {formatNumber(item.ValueGoc + item.ValuePaid)}
            </td>
          )}
          <td className="text-right">{formatNumber(item.OtheFee)}</td>
          {isShowPhiKho && (
            <td className="text-right">{formatNumber(item.PhiKho)}</td>
          )}
          <td className="text-right color-xanh">{formatNumber(item.Paided)}</td>
          <td className="text-center color-xanh">
            <div>
              {lstTP.map((itemPaid, idexTP) => {
                var itemPaids = itemPaid.split("#");
                if (itemPaids.length > 3) {
                  if (itemPaids[3] == "False") {
                    return;
                  }
                }

                return (
                  <p className="text-center" key={"thuCHi" + idexTP}>
                    {formatNumber(itemPaids[2]).replace(".00", "")}
                    <br />
                    <span className="date-sm color7">
                      ({getDate(itemPaids[1])})
                    </span>
                  </p>
                );
              })}
            </div>
          </td>
        </tr>
      );
    });
  }
  render() {
    let {
      TongTienLai,
      TongTienGoc,
      TongPhiKho,
      TongPhiKhac,
      TongThanhToan,
      List,
      pageIndex,
      totalRow,
      TongPhiKhacHangKy,
      pageSize,
      handlePageChange,
      showPhiKho,
      Type,
      StatusPaidHo,
      TongPhiDongLaiCham,
    } = this.props;
    console.log("Lần thanh toán");
    console.log(this.props);
    let showLai =
      Type !== 2 || (Type === 2 && (StatusPaidHo === 2 || StatusPaidHo === 3));
    let showGoc =
      Type !== 2 || (Type === 2 && (StatusPaidHo === 2 || StatusPaidHo === 3));
    let showGop = Type === 2 && StatusPaidHo === 1;
    let isShowPhiKho = showPhiKho && Type !== 2 && Type !== 1;
    console.log(showLai);

    return (
      <div className="row table-responsive">
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="Left808x200  Table-main-morman table-noboder-new col-xl-12 col-lg-12">
              <div>
                <table
                  className="table table-bordered table-hover color7  table-rounded"
                  cellSpacing="0"
                  rules="all"
                  border="0"
                  id=""
                  style={{ borderWidth: "0px", borderCollapse: "collapse" }}
                >
                  <tbody>
                    <tr className="table-header">
                      <th scope="col">
                        <span className="color-do-bold">[ {totalRow} ]</span>
                        <br />
                        &nbsp;
                      </th>
                      <th className="text-left w-10 color-tim-bold" scope="col">
                        <span className="color-tim-bold"> Ngày thanh toán</span>{" "}
                        <br />
                        &nbsp;
                      </th>
                      {showLai && (
                        <th className="text-right color-tim-bold" scope="col">
                          <span className="color-tim-bold"> Tiền lãi</span>
                          <br />
                          <span className="color-do-bold">
                            {formatNumber(TongTienLai)}
                          </span>
                        </th>
                      )}
                      <th className="text-right color-tim-bold" scope="col">
                        <span className="color-tim-bold"> Phí hàng kỳ</span>
                        <br />
                        <span className="color-do-bold">
                          {formatNumber(TongPhiKhacHangKy)}
                        </span>
                      </th>
                      <th className="text-right color7-bold" scope="col">
                        Phí phạt
                        <br />
                        <span className="color-do-bold">
                          {formatNumber(TongPhiDongLaiCham)}
                        </span>
                      </th>
                      {showGoc && (
                        <th className="text-right color-tim-bold" scope="col">
                          <span className="color-tim-bold"> Tiền gốc</span>
                          <br />
                          <span className="color-do-bold">
                            {formatNumber(TongTienGoc)}
                          </span>
                        </th>
                      )}
                      {showGop && (
                        <th className="text-right color-tim-bold" scope="col">
                          <span className="color-tim-bold"> Tiền góp</span>
                          <br />
                          <span className="color-do-bold">
                            {formatNumber(TongTienGoc + TongTienLai)}
                          </span>
                        </th>
                      )}

                      <th className="text-right color-tim-bold" scope="col">
                        <span className="color-tim-bold"> Phí khác</span>
                        <br />
                        <span className="color-do-bold">
                          {formatNumber(TongPhiKhac)}
                        </span>
                      </th>
                      {isShowPhiKho && (
                        <th className="text-right color-tim-bold" scope="col">
                          <span className="color-tim-bold"> Phí kho</span>
                          <br />

                          <span className="color-do-bold">
                            {formatNumber(TongPhiKho)}
                          </span>
                        </th>
                      )}

                      <th className="text-right" scope="col">
                        <span className="color-tim-bold"> Đã thanh toán</span>
                        <br />

                        <span className="color-xanh-bold">
                          {formatNumber(TongThanhToan)}
                        </span>
                      </th>
                      <th scope="col color-tim-bold">
                        {" "}
                        <span className="color-tim-bold"> Các lần đóng</span>
                        <br />
                        &nbsp;{" "}
                      </th>
                    </tr>

                    {this.renderRow(List)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-page-new col-xl-12 col-lg-12">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="paniation-new d-flex just-end">
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={totalRow}
                    pageRangeDisplayed={10}
                    onChange={handlePageChange}
                    itemClass="page-item s"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default LanThanhToanTable;
